import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { FooterComponent } from './pages/footer/footer.component';
import { HomeComponent } from './pages/home/home.component';
import { RealTimeProtecttComponent } from './pages/real-time-protectt/real-time-protectt.component';
import { MobileProtecttComponent } from './pages/mobile-protectt/mobile-protectt.component';

import { AppProtecttComponent } from './pages/app-protectt/app-protectt.component';
import { ByodComponent } from './pages/byod/byod.component';
import { FrmComponent } from './pages/frm/frm.component';
import { RaspComponent } from './pages/rasp/rasp.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { LeadershipTeamComponent } from './pages/leadership-team/leadership-team.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CyberLabServicesComponent } from './pages/cyber-lab-services/cyber-lab-services.component';
import { AboutMobileSecurityComponent } from './pages/about-mobile-security/about-mobile-security.component';
import { IosComponent } from './pages/ios/ios.component';
import { AndroidComponent } from './pages/android/android.component';
import { CommunityComponent } from './pages/community/community.component';
import { LifeAtProtecttAiComponent } from './pages/life-at-protectt-ai/life-at-protectt-ai.component';
import { CareerComponent } from './pages/career/career.component';
import { BlogsComponent } from './pages/blogs/blogs.component';
import { EnhancingMobileAppSecurityThroughRaspComponent } from './pages/blogs/blog-details/enhancing-mobile-app-security-through-rasp/enhancing-mobile-app-security-through-rasp.component';
import { FiveWaysToEnhanceYourAndroidPhoneSecurityComponent } from './pages/blogs/blog-details/five-ways-to-enhance-your-android-phone-security/five-ways-to-enhance-your-android-phone-security.component';
import { SmartphoneAntivirusNeedOfTheHourComponent } from './pages/blogs/blog-details/smartphone-antivirus-need-of-the-hour/smartphone-antivirus-need-of-the-hour.component';
import { SevenMustHaveAppsOnYourSmartphoneComponent } from './pages/blogs/blog-details/seven-must-have-apps-on-your-smartphone/seven-must-have-apps-on-your-smartphone.component';
import { BlogSidebarComponent } from './pages/blog-sidebar/blog-sidebar.component';
import { MobileDeviceSecurityComponent } from './pages/mobile-device-security/mobile-device-security.component';
import { CustomersComponent } from './pages/customers/customers.component';
import { DeleteComponent } from './pages/delete/delete.component';
import { PartnersComponent } from './pages/partners/partners.component';
import { IndustryNewsComponent } from './pages/industry-news/industry-news.component';
import { CaseStudiesComponent } from './pages/case-studies/case-studies.component';
import { PlatformComponent } from './pages/platform/platform.component';
import {
  NgcCookieConsentModule,
  NgcCookieConsentConfig,
} from 'ngx-cookieconsent';
import { CorporateprivacypolicyComponent } from './pages/corporateprivacypolicy/corporateprivacypolicy.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AppProtecttLiteComponent } from './pages/app-protectt-lite/app-protectt-lite.component';
import { CommonMobileBankingAppFraudsAndProtectionComponent } from './pages/common-mobile-banking-app-frauds-and-protection/common-mobile-banking-app-frauds-and-protection.component';
import { ProtectYourCorporateMobileAppFromReverseEngineeringComponent } from './pages/blogs/blog-details/protect-your-corporate-mobile-app-from-reverse-engineering/protect-your-corporate-mobile-app-from-reverse-engineering.component';
import { HowMobileAppSpoofingImpactsBusinessComponent } from './pages/blogs/blog-details/how-mobile-app-spoofing-impacts-business/how-mobile-app-spoofing-impacts-business.component';
import { RbiControlSolutionComponent } from './pages/rbi-control-solution/rbi-control-solution.component';
import { ZeroTrustBindingComponent } from './pages/zero-trust-binding/zero-trust-binding.component';
import { UnsecuredWifiComponent } from './pages/blogs/blog-details/unsecured-wifi/unsecured-wifi.component';
import { MediaComponent } from './pages/media/media.component';
import { MobilePaymentsApplicationSecurityControlsComponent } from './pages/blogs/blog-details/mobile-payments-application-security-controls/mobile-payments-application-security-controls.component';
import { environment } from 'src/environments/environment';
import { UnsubscribeEmailComponent } from './pages/unsubscribe-email/unsubscribe-email.component';
import { SixImportantTipsForMobileDataComponent } from './pages/blogs/blog-details/six-important-tips-for-mobile-data/six-important-tips-for-mobile-data/six-important-tips-for-mobile-data.component';
import { FourWaysToImproveTheMobileApplicationComponent } from './pages/blogs/blog-details/four-ways-to-improve-the-mobile-application/four-ways-to-improve-the-mobile-application.component';
import { AppprotecttmobileappsecurityComponent } from './pages/appprotecttmobileappsecurity/appprotecttmobileappsecurity.component';
import { ThankyouComponent } from './pages/thankyou/thankyou.component';
import { SwiperModule } from 'swiper/angular';
import { EbrochureComponent } from './pages/ebrochure/ebrochure.component';
import { ProtectYourSensitiveMobileAppsComponent } from './pages/blogs/blog-details/protect-your-sensitive-mobile-apps/protect-your-sensitive-mobile-apps.component';
import { AppbindlandingComponent } from './pages/appbindlanding/appbindlanding.component';
import { AppbindthankyouComponent } from './pages/appbindthankyou/appbindthankyou.component';
import { ZeroTrustDeviceBindingComponent } from './pages/blogs/blog-details/zero-trust-device-binding/zero-trust-device-binding.component';
import { PressReleaseComponent } from './pages/press-release/press-release.component';
import { MegaheaderComponent } from './pages/megaheader/megaheader.component';
import { ReverseEngineeringOnAndroidMobileApplicationComponent } from './pages/blogs/blog-details/reverse-engineering-on-android-mobile-application/reverse-engineering-on-android-mobile-application.component';
import { ProtectSensitiveAppOnrootedDeviceComponent } from './pages/blogs/blog-details/protecting-sensitive-mobile-apps-on-rooted-device/protecting-sensitive-mobile-apps-on-rooted-device.component';
import { RaspInEraOfDevsecopsComponent } from './pages/blogs/blog-details/rasp-in-era-of-devsecops/rasp-in-era-of-devsecops.component';
import { PressReleaseDsciFinsecAwardComponent } from './pages/press-release-dsci-finsec-award/press-release-dsci-finsec-award.component';
import { RiskAndImpectsOfAccessibilityPermissionComponent } from './pages/blogs/blog-details/risk-and-impects-of-accessibility-permission/risk-and-impects-of-accessibility-permission.component';
import { HeaderComponent } from './pages/header-old/header-old.component';
import { WebinarComponent } from './pages/webinar/webinar.component';
import { ThankyouwebinarComponent } from './pages/thankyouwebinar/thankyouwebinar.component';
import { WhatCustomersComponent } from './pages/what-customers/what-customers.component';
import { AboutProtecttaiComponent } from './pages/about-protecttai/about-protecttai.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AwardsandrecognitionComponent } from './pages/awardsandrecognition/awardsandrecognition.component';
import { HomeBlogsComponent } from './pages/home-blogs/home-blogs.component';
import { CodeProtecttComponent } from './pages/code-protectt/code-protectt.component';
import { WebinarvideoComponent } from './pages/webinarvideo/webinarvideo.component';
import { DeviceandsimbindingComponent } from './pages/blogs/blog-details/deviceandsimbinding/deviceandsimbinding.component';
import { SafeguardAgainstBankingAndFinancialFraudsThroughPhishingLinksComponent } from './pages/blogs/blog-details/safeguard-against-banking-and-financial-frauds-through-phishing-links/safeguard-against-banking-and-financial-frauds-through-phishing-links.component';
import { SimAndDeviceBindingMitigatingComponent } from './pages/blogs/blog-details/sim-and-device-binding-mitigating/sim-and-device-binding-mitigating.component';
import { SimBindingSolutionProtectSimSwapFraudsComponent } from './pages/blogs/blog-details/sim-binding-solution-protect-sim-swap-frauds/sim-binding-solution-protect-sim-swap-frauds.component';
import { SecureYourFinancialTransactionsComponent } from './pages/blogs/blog-details/secure-your-financial-transactions/secure-your-financial-transactions.component';

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: 'protectt.ai' //environment.domain_name, // v2.protectt.ai
  },
  "position": "bottom",
  "theme": "edgeless",
  "palette": {
    "popup": {
      "background": "#1a3f6e",
      "text": "#ffffff",
      "link": "#ffffff"
    },
    "button": {
      "background": "#d82b27",
      "text": "#ffffff",
      "border": "transparent",
    }
  },
  "type": "info",
  "content": {
    "message": "This website uses cookies to ensure you get the best experience.",
    "dismiss": "Got it!",
    "deny": "Refuse cookies",
    "link": "Learn more",
    "href": "https://cookiesandyou.com",
    "policy": "Cookie Policy"
  }
};

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    RealTimeProtecttComponent,
    MobileProtecttComponent,
    AppProtecttComponent,
    ByodComponent,
    FrmComponent,
    RaspComponent,
    AboutUsComponent,
    LeadershipTeamComponent,
    CyberLabServicesComponent,
    AboutMobileSecurityComponent,
    IosComponent,
    AndroidComponent,
    CommunityComponent,
    LifeAtProtecttAiComponent,
    CareerComponent,
    BlogsComponent,
    EnhancingMobileAppSecurityThroughRaspComponent,
    FiveWaysToEnhanceYourAndroidPhoneSecurityComponent,
    SmartphoneAntivirusNeedOfTheHourComponent,
    SevenMustHaveAppsOnYourSmartphoneComponent,
    BlogSidebarComponent,
    MobileDeviceSecurityComponent,
    CustomersComponent,
    DeleteComponent,
    PartnersComponent,
    IndustryNewsComponent,
    CaseStudiesComponent,
    PlatformComponent,
    CorporateprivacypolicyComponent,
    AppProtecttLiteComponent,
    CommonMobileBankingAppFraudsAndProtectionComponent,
    ProtectYourCorporateMobileAppFromReverseEngineeringComponent,
    ProtectYourSensitiveMobileAppsComponent,
    HowMobileAppSpoofingImpactsBusinessComponent,
    RbiControlSolutionComponent,
    ZeroTrustBindingComponent,
    UnsecuredWifiComponent,
    MediaComponent,
    MobilePaymentsApplicationSecurityControlsComponent,
    UnsubscribeEmailComponent,
    SixImportantTipsForMobileDataComponent,
    FourWaysToImproveTheMobileApplicationComponent,
    AppprotecttmobileappsecurityComponent,
    ThankyouComponent,
    EbrochureComponent,
    AppbindlandingComponent,
    AppbindthankyouComponent,
    ZeroTrustDeviceBindingComponent,
    MegaheaderComponent,
    PressReleaseComponent,
    ReverseEngineeringOnAndroidMobileApplicationComponent,
    PressReleaseDsciFinsecAwardComponent,
    RiskAndImpectsOfAccessibilityPermissionComponent,
    ProtectSensitiveAppOnrootedDeviceComponent,
    RaspInEraOfDevsecopsComponent,
    WebinarComponent,
    ThankyouwebinarComponent,
    WhatCustomersComponent,
    AboutProtecttaiComponent,
    AwardsandrecognitionComponent,
    HomeBlogsComponent,
    CodeProtecttComponent,
    WebinarvideoComponent,
    DeviceandsimbindingComponent,
    SafeguardAgainstBankingAndFinancialFraudsThroughPhishingLinksComponent,
    SimAndDeviceBindingMitigatingComponent,
    SimBindingSolutionProtectSimSwapFraudsComponent,
    SecureYourFinancialTransactionsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    SlickCarouselModule,
    NgcCookieConsentModule.forRoot(cookieConfig),
    RouterModule.forRoot([
      { path: 'real-time-protectt', component: RealTimeProtecttComponent },
      { path: 'mobile-protectt', component: MobileProtecttComponent },
      { path: 'app-protectt', component: AppProtecttComponent },
      { path: 'byod', component: ByodComponent },
      { path: 'frm', component: FrmComponent },
      { path: 'rasp', component: RaspComponent },
      { path: 'community', component: CommunityComponent },
    ]),

    ModalModule.forRoot(),
    SwiperModule,
  ],
  // providers: [Location, {provide: LocationStrategy, useClass: HashLocationStrategy}],
  bootstrap: [AppComponent],
})
export class AppModule { }
